<template>
	<form-remote-select v-bind="props"
						@update:modelValue="value => emit('update:modelValue', value)"
						@select="option => emit('select', option)"
						action="/v1/suggests/athletes"
						initial-option-action="/v1/athletes"
						text-prop="display_name"
						value-prop="id"
						subtitle-prop="coarse_address"
						image-prop="avatar_thumbnail"
						:data="requestParams"/>
</template>

<script setup lang="ts">
import {computed} from 'vue';

const props = withDefaults(defineProps<{
	params?: object
}>(), {
	params: {}
});
const emit = defineEmits(['update:modelValue', 'select']);

const requestParams = computed(() => {
	return {
		limit: 25,
		...props.params,
	};
});
</script>